import React from "react";
import api from "../services/api";
import Navbar from "../components/Navbar";
import { Helmet } from 'react-helmet-async';
import { loadRazorpay } from "../utils/loadRazorpay";
import { useAuth } from "../utils/auth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const MembershipPlan = () => {
  const navigate = useNavigate();

  const { user, loading } = useAuth();


  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate("/login");
      } else if (user.plan_status !== "ACTIVE") {
        navigate("/membership-plan");
      }
    }
  }, [user, loading, navigate]);

  const hasActivePlan = user?.plan_status === "ACTIVE";

  const handleSubscribe = async () => {
    const loaded = await loadRazorpay();
    if (!loaded) {
      alert("Failed to load Razorpay SDK");
      return;
    }

    const response = await api.post("/api/create-order", {}, {
      withCredentials: true
    });

    const order = response.data;

    const options = {
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      name: "Art India Education",
      description: "Subscription payment for Art India Education",
      image: "/Black-logo-without-tagline.svg",
      order_id: order.order_id,
      prefill: {
        "name": user.first_name
        //     "email": user.email_address,
        //     "contact": user.phone_number
      },
      handler: async function (response) {
        try {
          const formData = new FormData();
          formData.append("razorpay_payment_id", response.razorpay_payment_id);
          formData.append("razorpay_order_id", response.razorpay_order_id);
          formData.append("razorpay_signature", response.razorpay_signature);

          const verifyRes = await api.post("/api/verify", formData, {
            withCredentials: true,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          console.log('verifyRes.data', verifyRes.data);
          if (verifyRes.data.redirect) {
            navigate(verifyRes.data.redirect);
          } else {
            alert("Verification failed");
          }
        } catch (err) {
          console.error("Verification error:", err);
          alert("Payment verification failed.");
        }
      },
      notes: {
        "address": "JSW Centre MMRDA, Mumbai, Maharashtra 400051"
      },
      theme: {
        "color": "#EA7E5D"
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <>
      <Helmet>
        <title>Membership Plan - Art India Education</title>
      </Helmet>
      <Navbar />
      <main>
        <section className="relative h-screen w-full overflow-hidden font-['EB_Garamond','Nunito','sans-serif']">
          <div className="relative w-full h-full overflow-hidden">
            <div className="absolute inset-0 bg-black/50 z-10"></div>
            <img
              src="membership-baner-background.jpg"
              alt="banner"
              className="absolute top-[-25%] h-[150%] w-full object-cover z-0"
            />

            {/* 🧾 Membership Box */}
            <div className="absolute inset-0 z-20 flex justify-center items-center px-4">
              <div className="bg-black/60 backdrop-blur-md text-white rounded-lg p-8 max-w-xl w-full text-center border border-white/30">

                {/* Display message if plan is active */}
                {hasActivePlan && (
                  <div className="text-md font-semibold text-green-300 mb-4">
                    Your Current Membership: <span className="font-bold">Annual Plan</span>
                  </div>
                )}

                <h2 className="text-xl font-bold mb-4 pb-5">ANNUAL PLAN</h2>
                <p className="text-4xl font-extrabold mb-6">
                  ₹999.00 <span className="text-2xl font-semibold">+ GST</span>
                </p>

                <ul className="text-left space-y-2 mb-6 p-12">
                  <li className="flex items-center">
                    <span className="text-[rgb(234,126,93)] font-bold mr-2">✔</span> Unlimited access to content
                  </li>
                  <li className="flex items-center">
                    <span className="text-[rgb(234,126,93)] font-bold mr-2">✔</span> Learn at your own pace
                  </li>
                  <li className="flex items-center">
                    <span className="text-[rgb(234,126,93)] font-bold mr-2">✔</span> One-time payment
                  </li>
                  <li className="flex items-center">
                    <span className="text-[rgb(234,126,93)] font-bold mr-2">✔</span> Valid for up to one year
                  </li>
                </ul>

                <hr className="border-t border-white/40 my-6" />

                <p className="mb-4 text-lg">Powered by Razorpay</p>

                <button
                  disabled={hasActivePlan}
                  className={`w-full px-6 py-2 font-bold rounded-md transition ${hasActivePlan
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-[rgb(234,126,93)] text-white hover:bg-opacity-90"
                    }`}
                  onClick={handleSubscribe}
                >
                  {hasActivePlan ? "Subscription Active" : "Start Subscription"}
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default MembershipPlan;